/**
 * useInvestorPortfolio Hook
 * React Query hook for fetching the investor's cross-tenant portfolio view.
 */

import { useQuery } from "@tanstack/react-query";
import type { InvestorPortfolioResponse } from "@app/types";
import apiClient from "@/lib/api-client";
import { useAuth } from "@/contexts/AuthContext";

export function useInvestorPortfolio() {
  const { isAuthenticated } = useAuth();

  const { data, isLoading, error } = useQuery<InvestorPortfolioResponse, Error>(
    {
      queryKey: ["investor-portfolio"],
      queryFn: async () => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { data, error: apiError } = await apiClient.GET(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          "/investor/portfolio" as any,
        );

        if (apiError) {
          throw new Error("Failed to fetch portfolio");
        }

        return data as InvestorPortfolioResponse;
      },
      enabled: isAuthenticated,
      staleTime: 2 * 60 * 1000, // 2 minutes
    },
  );

  return {
    funds: data?.funds || [],
    isLoading,
    error,
  };
}
